import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
  createSelector
} from '@reduxjs/toolkit'


import { generatePhoneDetail } from '../utils/phoneUtil'

import vipHostService from '../services/vipHostService'


export const fetchAllVipHosts = createAsyncThunk('vipHost/fetchAllVipHosts', 
  async () => {
    const response = await vipHostService.fetchAll()
    return response.data
})

export const fetchVipHost = createAsyncThunk('vipHost/fetchVipHost', 
  async (id) => {
    const response = await vipHostService.fetch(id)
    return response.data
})
export const createVipHost = createAsyncThunk('vipHost/createVipHost', 
  async (vipHost) => {
    const response = await vipHostService.create(vipHost)
    return response.data
})
export const updateVipHost = createAsyncThunk('vipHost/updateVipHost', 
  async (vipHost) => {
    const response = await vipHostService.update(vipHost)
    return response.data
})
export const deleteVipHost = createAsyncThunk('vipHost/deleteVipHost', 
  async (id) => {
    const response = await vipHostService.delete(id)
    return response.data
})



const vipHostAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  sortComparer: (a, b) => a.email.toLowerCase().localeCompare(b.email.toLowerCase())
})

const initialState = vipHostAdapter.getInitialState();

const vipHostSlice = createSlice({
  name: 'vipHost',
  initialState: initialState,
  reducers: {
    clearVipHosts(state, action) {
      state.error=null
      state.status='idle'
      vipHostAdapter.removeAll(state)
    },
    vipHostsSyncLoaded: {
      reducer(state, action) {
        if (action.payload)
        {
          action.payload.forEach(generatePhoneDetail);
        }
        vipHostAdapter.setAll(state, action.payload)
      },
      prepare(vipHostList) {
        return {payload:vipHostList}
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllVipHosts.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchAllVipHosts.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload)
        {
          action.payload.forEach(element => {
            generatePhoneDetail(element)
          });
        }
        vipHostAdapter.setAll(state, action.payload)
        
      })
      .addCase(fetchAllVipHosts.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(fetchVipHost.fulfilled, (state, action) => {

        if (action.payload)
        {
            generatePhoneDetail(action.payload)
        }
        vipHostAdapter.upsertOne(state, action.payload)
      })
      .addCase(createVipHost.fulfilled, (state, action) => {
        if (action.payload)
        {
            generatePhoneDetail(action.payload)
        }
        vipHostAdapter.addOne(state,action.payload)
      })
      .addCase(updateVipHost.fulfilled, (state, action) => {
        if (action.payload)
        {
            generatePhoneDetail(action.payload)
        }
        vipHostAdapter.upsertOne(state , action.payload)
      })
      .addCase(deleteVipHost.fulfilled, (state, action) => {
        vipHostAdapter.removeOne(state,action.payload)
      })
  }
}
)

export const { vipHostsSyncLoaded,clearVipHosts } = vipHostSlice.actions

export default vipHostSlice.reducer;

export const {
  selectAll:  selectAllVipHosts,
  selectById: xselectVipHostById,
  selectIds:  selectAllVipHostIds,
} = vipHostAdapter.getSelectors((state) => state.vipHost)


export const selectVipHostById = (id)=>(state)=>xselectVipHostById(state, id)

const filterPredicate =(r, f)=>{
  if (!Boolean(f)) return true;

  return Boolean(r.email) && r.email.toLowerCase().includes(f) || (Boolean(r.phone) && r.phone.includes(f));
} 

export const selectVipHostIdsByFilter = 
createSelector(
  [	selectAllVipHosts, 	(state, filter)=>(filter?filter.toLowerCase():'')],
  (vipHosts, fff) =>vipHosts.filter( v=>filterPredicate(v, fff) ).map(x=>x.id)
)



